import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from '@/components/ui/Sidebar';
import { Topbar } from '@/components/ui/Topbar';
import { useState, useEffect } from 'react';
import { FloatingHelpButton } from '@/landing/v3/sections/FloatingHelpButton';
import { GlobalSalesBanner } from '@/components/common/GlobalSalesBanner';
import { DraMediSupportWidget } from '@/components/support/DraMediSupportWidget';

export function MainLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  // Fecha o drawer mobile automaticamente ao navegar
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex h-screen bg-background overflow-hidden relative">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Banner Global do Motor de Vendas no Topo */}
        <GlobalSalesBanner />
        <Topbar onMenuClick={() => setMobileOpen((prev) => !prev)} />
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>

      {/* Assistente IA In-Page com controle de tela */}
      <FloatingHelpButton />
      {/* Widget Oficial de Suporte da Dra. Medi (com verificação de pagamento) */}
      <DraMediSupportWidget />
    </div>
  );
}
